/**
 * TanStack Router: /vacation/calendar
 *
 * This route file was auto-generated by the route generation script.
 * Component: VacationCalendarPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import VacationCalendarPage from '@/app/vacation/calendar/page'

/**
 * Route: /vacation/calendar
 * Layout: _auth (authenticated)
 * Component: VacationCalendarPage
 */
export const Route = createFileRoute('/_auth/vacation/calendar')({
  component: VacationCalendarPage,
})
